import { api } from "./BackendService";

export const get = () => api.get(`/cp/databases`);